import MarkerGroup from "./MarkerGroup";
import PrimaryMarkerGroup from "./PrimaryMarkerGroup";
import LineMarkerGroup from "./LineMarkerGroup";
import ClusterHandler from "./ClusterHandler";

const MarkerGroups = ({
  restServicePost,
  apiToken,
  onClickCluster,
  queryString,
  showPrimaryGroup,
  primaryGroupShortCode,
  primaryGroupDestinationEvents,
  singleNonMDDestinationEvent,
  isMultiDestination,
  clusteringEnabled,
  markerOptions,
  setActiveDestinationEventSelectedOnMap,
  togglePolyPopUp,
  mapBounds,
  zoom,
  enableSources,
}) => {
  var renderedBasicMarkerOptions = markerOptions.filter(
    (markerOption) =>
      markerOption.isFocused && markerOption.marker.type !== "Lines"
  );
  var renderedLineMarkerOptions = markerOptions.filter(
    (markerOption) =>
      markerOption.isFocused && markerOption.marker.type === "Lines"
  );

  return (
    <>
      {showPrimaryGroup && (
        <ClusterHandler onClickCluster={onClickCluster}>
          <PrimaryMarkerGroup
            isMultiDestination={isMultiDestination}
            singleNonMDDestinationEvent={singleNonMDDestinationEvent}
            clusteringEnabled={clusteringEnabled}
            setActiveDestinationEventSelectedOnMap={
              setActiveDestinationEventSelectedOnMap
            }
            destinationEvents={primaryGroupDestinationEvents}
          />
        </ClusterHandler>
      )}
      {renderedBasicMarkerOptions.map((markerOption, index) => (
        <ClusterHandler
          key={markerOption.destinationGroupShortCode}
          onClickCluster={onClickCluster}
        >
          <MarkerGroup
            restServicePost={restServicePost}
            apiToken={apiToken}
            queryString={queryString}
            setActiveDestinationEventSelectedOnMap={
              setActiveDestinationEventSelectedOnMap
            }
            onClickCluster={onClickCluster}
            primaryGroupShortCode={primaryGroupShortCode}
            markerOption={markerOption}
            isMultiDestination={isMultiDestination}
            mapBounds={mapBounds}
            zoom={zoom}
          />
        </ClusterHandler>
      ))}
      {renderedLineMarkerOptions.map((markerOption, index) => (
        <LineMarkerGroup
          key={"line" + index}
          lineData={markerOption.marker.polyLine}
          togglePolyPopUp={togglePolyPopUp}
          enableSources={enableSources}
        />
      ))}
    </>
  );
};

export default MarkerGroups;
